module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 dates.forEach(function(date, i) { 
__p+='\n	';
 if (date.livestreams.length || (!date.livestreams.length && showEmptyDays)) { 
__p+='\n		<div class="live-class__calendar-day ';
 if (date.livestreams.length == 0) { 
__p+='live-class__calendar-day--no-classes';
 } 
__p+=' spy-section" id="'+
((__t=( date.dateId ))==null?'':__t)+
'">\n			';
 if (showEmptyDays) { 
__p+='\n				<h3 class="live-class__calendar-day-title">\n					';
 if (date.isToday) { 
__p+='\n						Today\n					';
 } else { 
__p+='\n						'+
((__t=( date.longFormatedDate ))==null?'':__t)+
'\n					';
 } 
__p+='\n				</h3>\n			';
 } else { 
__p+='\n				<span class="live-class__card-date">\n					';
 if (date.isToday) { 
__p+='\n						Today\n					';
 } else { 
__p+='\n						'+
((__t=( date.longFormatedDate ))==null?'':__t)+
'\n					';
 } 
__p+='\n				</span>\n			';
 } 
__p+='\n\n			';
 if (date.livestreams.length == 0) { 
__p+='\n				<p class="live-class__no-classes">No classes</p>\n			';
 } else { 
__p+='\n				';
 date.livestreams.forEach(function(live) { 
__p+='\n					<div class="live-class__card ';
 if (live.status === 'complete' || live.status === 'cancelled') { 
__p+='live-class__card-start-time--disabled';
 } 
__p+='" onclick="window.location = \'/live?livestream-details=\' + '+
((__t=( live.id ))==null?'':__t)+
';" onkeydown="javascript: if(event.keyCode == 13) window.location = \'/live?livestream-details=\' + '+
((__t=( live.id ))==null?'':__t)+
';" role="button" tabindex="0">\n						<div class="live-class__time-container">\n							<p class="live-class__card-start-time f-uppercase">'+
((__t=( live.formattedTimeLive ))==null?'':__t)+
'</p>\n\n							';
 if (live.status === 'live' || live.status === 'queued') { 
__p+='\n								<p class="badge badge--pill badge--small-type badge--live-class-live f-uppercase">Live</p>\n							';
 } else if (live.status === 'complete') { 
__p+='\n								<p class="badge badge--pill badge--small-type badge--live-class-completed f-uppercase">Live</p>\n							';
 } else { 
__p+='\n								<p class="badge badge--pill badge--small-type badge--live-class-upcoming f-uppercase">Live</p>\n							';
 } 
__p+='\n						</div>\n\n						<div class="live-class__card-avatar-container">\n							<img src="';
 if (live.teacher.avatarImage) { 
__p+=''+
((__t=( live.teacher.avatarImage ))==null?'':__t)+
'';
 } else { 
__p+='{{cdn}}/img/card-placeholders/teacher-profile.jpg';
 } 
__p+='" alt="Teacher avatar" class="live-class__card-avatar">\n						</div>\n\n						<div class="live-class__card-details">\n							<h3 class="live-class__card-title f-medium ';
 if (live.status === 'complete' || live.status === 'cancelled') { 
__p+='live-class__card-title--disabled';
 } 
__p+='">\n								'+
((__t=( live.name ))==null?'':__t)+
'\n							</h3>\n\n							<p class="live-class__card-meta-detail">\n								';
 if (live.style) { 
__p+='\n									<span class="live-class__card-modality-style">\n										'+
((__t=( live.style.modality.name ))==null?'':__t)+
' • <a href="/styles/'+
((__t=( live.style.slug ))==null?'':__t)+
'" class="f-link--no-underline">'+
((__t=( live.style.name ))==null?'':__t)+
'</a>\n									</span>\n								';
 } 
__p+='\n\n								<span class="live-class__card-teacher-name">\n									<span>•</span>\n									';
 if (live.teacher.role === 'marketplace') { 
__p+='\n										<span>'+
((__t=( live.teacher.firstName ))==null?'':__t)+
' '+
((__t=( live.teacher.lastName ))==null?'':__t)+
'</span>\n									';
 } else { 
__p+='\n										<a href="/teachers/'+
((__t=( live.teacher.slug ))==null?'':__t)+
'" class="f-link--no-underline">'+
((__t=( live.teacher.firstName ))==null?'':__t)+
' '+
((__t=( live.teacher.lastName ))==null?'':__t)+
'</a>\n									';
 } 
__p+='\n								</span>\n							</p>\n\n							<div class="live-class__card-badges">\n								';
 if (live.level) { 
__p+='\n									<span class="badge badge--outline">\n										<picture>\n											<img\n												src="'+
((__t=( cdn ))==null?'':__t)+
'/img/icons/class/level.svg"\n												alt=""\n												loading="lazy"\n												class="live-class__badge-icon"\n											>\n										</picture> Level '+
((__t=( live.level.name ))==null?'':__t)+
'\n									</span>\n								';
 } 
__p+='\n\n								';
 if (live.intensity) { 
__p+='\n									<span class="badge badge--outline">\n										<picture>\n											<img\n												src="'+
((__t=(live.intensity.assets.cardIcon.svg))==null?'':__t)+
'"\n												alt=""\n												loading="lazy"\n												class="live-class__badge-icon live-class__badge-icon--intensity"\n											>\n										</picture> Intensity '+
((__t=( live.intensity.name ))==null?'':__t)+
'\n									</span>\n								';
 } 
__p+='\n							</div>\n						</div>\n\n						<div class="live-class__card-cta-container">\n							';
 if (live.status === 'complete')  { 
__p+='\n								<a href="/live?livestream-details='+
((__t=( live.id ))==null?'':__t)+
'" class="btn live-class__card-btn live-class__card-btn--chevron" aria-label="Go to live class details"></a>\n\n								';
 if ( live.totalUsersViewed > 4) { 
__p+='\n									<p class="live-class__card-attendee-count">'+
((__t=( live.totalUsersViewed ))==null?'':__t)+
' Attended</p>\n								';
 } 
__p+='\n							';
 } else if (live.status === 'cancelled') { 
__p+='\n								<button class="btn btn--yellow live-class__card-btn">Canceled</button>\n							';
 } else if (live.status === 'queued' || live.status === 'live') { 
__p+='\n								<a href="/v2/login?redirect=/live?livestream-details='+
((__t=( live.id ))==null?'':__t)+
'" class="btn btn--red live-class__card-btn">Practice Now</a>\n\n								';
 if ( live.totalViewingNow > 4) { 
__p+='\n									<p class="live-class__card-attendee-count">'+
((__t=( live.totalViewingNow  ))==null?'':__t)+
' Practicing</p>\n								';
 } 
__p+='\n							';
 } else { 
__p+='\n								<a href="/v2/login?redirect=/live?livestream-details='+
((__t=( live.id ))==null?'':__t)+
'" class="btn live-class__card-btn">\n									Count Me In\n								</a>\n\n								';
 if (live.totalUsersSubscribed > 4) { 
__p+='\n									<p class="live-class__card-attendee-count">'+
((__t=( live.totalUsersSubscribed ))==null?'':__t)+
' Signed Up</p>\n								';
 } 
__p+='\n							';
 } 
__p+='\n						</div>\n					</div>\n				';
 }) 
__p+='\n			';
 } 
__p+='\n		</div>\n	';
 } 
__p+='\n';
 }) 
__p+='\n';
}
return __p;
};
